import * as React from 'react';
import { v4 } from 'uuid';
import Styled from 'styled-components';

import { media } from '../../../lib/StyledComponents';
import { Checkbox, RadioInput } from '../../Form';

export interface IKBAOptionProps {
  multipleChoice?: boolean;
  groupName?: string;
}

const VerQaOption = Styled.div`
  label {
    height: auto;
  }

  ${media.medium`
    display: flex;
    align-items: center;

    input[type="checkbox"] + label {
      margin-bottom: 0.25em;
    }
  `}
`;

export default class KBAOption extends React.PureComponent<React.InputHTMLAttributes<HTMLInputElement> & IKBAOptionProps> {
  private readonly _id: string = v4();

  public render () {
    const { groupName, value, children, multipleChoice, ...rest } = this.props;
    const inputType = multipleChoice ? 'checkbox' : 'radio';

    return (
      <VerQaOption>
        {multipleChoice ?  (
          <Checkbox
            {...rest}
            type={inputType}
            name={groupName}
            id={this._id}
            value={value}
          >
            {children}
          </Checkbox>
        ) : (
          <RadioInput
            {...rest}
            type={inputType}
            name={groupName}
            id={this._id}
            value={value}
          >
            {children}
          </RadioInput>
        )}
      </VerQaOption>
    );
  }
}
